import * as React from 'react';

import classNames from 'classnames';

import { formatPhone } from '../../../utils/formatters';
import { IOfficeMapData } from '../index';

import * as styles from './index.css';

export const OfficePreview = (props: IOfficeMapData) => (
  <div className={styles['container']}>
    <div>
      <div className={styles['name']}>{props.name}</div>
      <div className={styles['address']}>{props.address}</div>
    </div>
    <div>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={`tel:+${props.phone}`}
        className={classNames(styles['phone'], 'iefix_color_main')}
      >
        {formatPhone(props.phone)}
      </a>
    </div>
  </div>
);
